<template>
    <div>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active">
                <div
                    v-if="inProgress || questions === null"
                    class="p-5 d-flex justify-content-center align-items-center">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
                <div v-else>
                    <ul class="c-list mb-4">
                        <li v-for="question in questions"
                            class="c-list__item c-list__item--add">
                            <div class="text-left d-block d-lg-flex justify-content-between align-items-center">
                                <div class="vc-question-title mb-2 mb-lg-0">
                                    {{ question.title }}
                                </div>
                                <div class="text-center text-lg-right mb-2 mb-lg-0">
                                    <button
                                        @click="modalEdit(question)"
                                        :disabled="hasSurvey"
                                        class="btn btn-yokumiru-blue btn-sm mr-1">編集
                                    </button>
                                    <button
                                        @click="modalDelete(question)"
                                        :disabled="hasSurvey"
                                        class="btn btn-danger btn-sm">削除
                                    </button>
                                    <button
                                        class="btn btn-yokumiru-white btn-sm ml-2 text-muted font-weight-bold"
                                        @click="onClickOrder(question, 'up')">↑
                                    </button>
                                    <button
                                        class="btn btn-yokumiru-white btn-sm text-muted font-weight-bold"
                                        @click="onClickOrder(question, 'down')">↓
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="d-flex justify-content-center align-items-center">
                        <button
                            @click="modalAdd"
                            :disabled="hasSurvey"
                            class="btn btn-yokumiru-orange btn-settings">
                            質問カードを追加
                        </button>
                    </div>

                    <div class="d-flex justify-content-end align-items-center mt-5">
                        <button
                            @click="onClickHealthSurveyTemplateEdit"
                            class="btn btn-success mr-2">
                            質問デッキ編集
                        </button>
                        <button
                            @click="onClickHealthSurveyTemplateDelete"
                            :disabled="hasSurvey"
                            class="btn btn-danger mr-2">
                            質問デッキ削除
                        </button>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="tabContentImportExport">-->
<!--            <b-form-file-->
<!--                v-model="file.object"-->
<!--                ref="fileinput"-->
<!--                accept="text/json"-->
<!--                class="d-none"-->
<!--                @change="onUpload">-->
<!--            </b-form-file>-->
<!--            <button-->
<!--                @click="onClickImport"-->
<!--                class="btn btn-yokumiru-orange mr-2">-->
<!--                インポート-->
<!--            </button>-->
<!--            <button-->
<!--                @click="onClickExport"-->
<!--                class="btn btn-yokumiru-orange">-->
<!--                エクスポート-->
<!--            </button>-->
<!--        </div>-->

        <div v-if="question !== null">
            <!--  追加・編集モーダル  -->
            <b-modal
                v-model="modalShow"
                :title="question.id ? '質問カード編集' : '質問カード追加'"
                @ok="handleOk"
                :ok-title="question.id ? '更新' : '追加'"
                ok-variant="yokumiru-orange"
                @cancel="modalShow = false"
                cancel-title="キャンセル"
                cancel-variant="yokumiru-gray">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group m-form__group">
                                <label>タイプを選択</label>
                                <select
                                    v-model="question.interview_question_type_id"
                                    @change="onChangeType"
                                    class="form-control m-input m-input--solid">
                                    <option :value="types.radio">ラジオボタン</option>
                                    <option :value="types.check">チェックボックス</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group m-form__group">
                                <label>質問を入力</label>
                                <input
                                    v-model="question.title"
                                    :class="{ 'is-invalid' : errors.title }"
                                    class="form-control m-input m-input--air"
                                    maxlength="255">
                                <div class="text-muted small mt-1">
                                    255文字以内で入力してください
                                </div>
                                <div
                                    v-if="errors.title"
                                    class="invalid-feedback d-block">
                                    {{ errors.title[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 「チェックボックス」or「ラジオボタン」選択時 -->
                    <template
                        v-if="question.interview_question_type_id === types.check ||
                        question.interview_question_type_id === types.radio">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group m-form__group">
                                    <label>選択肢を入力</label>
                                    <div v-for="(item, idx) in question.items" class="mb-2">
                                        <div class="d-flex align-items-center">
                                            <removable-text-input
                                                v-model="question.items[idx].title"
                                                :index="idx"
                                                :invalid="errors[`items.${idx}.title`]">
                                            </removable-text-input>
                                            <input
                                                v-model="question.items[idx].score"
                                                type="number"
                                                min="0"
                                                max="1000"
                                                :class="{ 'is-invalid' : errors[`items.${idx}.score`] }"
                                                class="inputScore form-control m-input m-input--air ml-2"
                                                placeholder="点数">
                                            <button
                                                class="btn btn-yokumiru-white ml-2 text-muted font-weight-bold"
                                                @click="onClickItemOrder(idx, 'up')">↑
                                            </button>
                                            <button
                                                class="btn btn-yokumiru-white ml-2 text-muted font-weight-bold"
                                                @click="onClickItemOrder(idx, 'down')">↓
                                            </button>
                                        </div>
                                        <div
                                            v-if="errors[`items.${idx}.title`]"
                                            class="invalid-feedback d-block">
                                            {{ errors[`items.${idx}.title`][0] }}
                                        </div>
                                        <div
                                            v-if="errors[`items.${idx}.score`]"
                                            class="invalid-feedback d-block">
                                            {{ errors[`items.${idx}.score`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="m-form__group form-group">
                                    <div class="btn btn-outline-success m-btn btn-sm" @click="addItem">
                                        +&nbsp;選択肢を追加
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </b-modal>

            <!--  削除モーダル  -->
            <b-modal
                v-model="modalDeleteShow"
                title="質問カード削除"
                @ok="handleDelete"
                ok-title= "削除"
                ok-variant="danger"
                cancel-title="キャンセル"
                cancel-variant="yokumiru-gray">
                <form @submit.stop.prevent="deleteQuestion">
                    <p class="text-center">下記の質問カードを削除してもよろしいですか？</p>

                    <div class="modal-body">
                        <h6>タイプ：</h6>
                        <p v-text="question.type.name"></p>
                        <hr>
                        <h6>質問：</h6>
                        <p v-text="question.title"></p>
                        <hr>
                        <h6>選択肢：</h6>
                        <div
                            v-for="item in question.items"
                            class="modalDeleteItems mt-3">
                            <div class="modalDeleteItemsInner d-flex">
                                <div>{{ item.title }}</div>
                                <div>{{ item.score }}点</div>
                            </div>
                            <hr>
                        </div>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
import constants from '../../constants'
import _ from 'lodash'

export default  {
    props: {
        healthSurveyTemplate: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            inProgress: false,
            question: null,
            questions: null,
            types: constants.interview_question_types,
            file: {
                name: null,
                object: null,
            },
            modalShow: false,
            modalDeleteShow: false,
            errors: {},
        }
    },

    computed: {
        /**
         * 回答データが存在するかどうか
         * @return {boolean}
         */
        hasSurvey: function () {
            if (!this.healthSurveyTemplate) return false
            return this.healthSurveyTemplate.health_surveys_count > 0
        },
    },

    watch: {
        healthSurveyTemplate: function() {
            this.fetchQuestions()
        },
    },

    created: function() {
        this.initQuestion()
        this.fetchQuestions()
        bus.$on('on-remove', this.removeItem)
    },

    methods: {
        /**
         * 質問取得
         */
        fetchQuestions: async function() {
            this.questions = null
            const endpoint = constants.admin.health_survey_templates.endpoint.base

            await axios.get(`${endpoint}/${this.healthSurveyTemplate.id}/questions`)
                .then(({data}) => {
                    this.questions = data.data
                })
        },

        /**
         * 質問モーダルの初期化
         *
         * @return {void}
         */
        initQuestion: function() {
            this.question = {
                interview_question_type_id: this.types.radio,
                type: {},
                title: null,
                flg_required: true,
                flg_other: false,
                items: [
                    { title: '' },
                ],
            };
        },

        /**
         * 追加ボタン押下時
         *
         * @return {void}
         */
        modalAdd: function() {
            this.initQuestion()
            this.modalShow = true
        },

        /**
         * 編集ボタン押下時
         */
        modalEdit: function(question) {
            this.question = _.clone(question)
            this.modalShow = true
        },

        /**
         * 削除ボタン押下時
         */
        modalDelete: function(question) {
            this.question = question
            this.modalDeleteShow = true
        },

        /**
         * 選択肢の追加
         *
         * @return {void}
         */
        addItem: function() {
            this.question.items.push( { title: '' } )
        },

        /**
         * 選択肢の削除
         */
        removeItem: function( idx ) {
            if (this.question.items.length < 2) {
                return
            }
            this.question.items.splice(idx, 1)
            this.question.items.forEach((item, idx) => item.order = idx + 1)
        },

        /**
         * 問診タイプ変更時
         */
        onChangeType: function() {
            if ( this.question.items.length < 1 ) {
                this.addItem()
            }
        },

        /**
         * モーダルウィンドウ
         * 登録クリック時
         */
        handleOk: function (e) {
            e.preventDefault()
            this.postQuestion()
        },

        /**
         * モーダルウィンドウ
         * 削除クリック時
         */
        handleDelete: function(e) {
            e.preventDefault()
            this.deleteQuestion()
        },

        /**
         * 質問の登録・更新
         *
         * @return {void}
         */
        postQuestion: function() {
            const params = this.prepareParams()

            if (this.question.id) {
                this.updateQuestion(params)
            } else {
                this.storeQuestion(params)
            }
        },

        /**
         * 質問項目の準備
         */
        prepareParams: function() {
            const params = _.clone(this.question)
            params.health_survey_template_id = this.healthSurveyTemplate.id
            params.items = this.question.items

            return params
        },

        /**
         * 質問の登録
         *
         * @return {void}
         */
        storeQuestion: function (params) {
            const endpoint = constants.admin.health_survey_questions.endpoint.base

            axios.post(endpoint, params)
                .then(({data}) => {
                    bus.$emit('alert-success', `質問カードを追加しました。`)
                    this.errors = {}
                    this.questions.push(data.data)
                    this.initQuestion()
                    this.modalShow = false
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')
                    ) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        } else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })
        },

        /**
         * 質問の更新
         */
        updateQuestion: function (params) {
            const endpoint = constants.admin.health_survey_questions.endpoint.base

            axios.put(`${endpoint}/${this.question.id}`, params)
                .then(({data}) => {
                    bus.$emit('alert-success', '質問カードを更新しました。')
                    const idx = this.questions.findIndex(question => {
                        return Number(question.id) === Number(data.data.id)
                    })
                    this.questions[idx] = data.data
                    this.initQuestion()
                    this.errors = {}
                    this.modalShow = false
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')
                    ) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        } else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })
        },

        /**
         * 質問の削除
         *
         * @return {void}
         */
        deleteQuestion: function() {
            const id = this.question.id
            const endpoint = constants.admin.health_survey_questions.endpoint.base

            axios.delete(`${endpoint}/${id}`)
                .then(() => {
                    bus.$emit('alert-success', '質問カードを削除しました。')
                    this.errors = []

                    const idx = this.questions.findIndex(question => {
                        return Number(question.id) === Number(id)
                    })

                    this.questions.splice(idx, 1)
                    this.initQuestion()
                    this.modalDeleteShow = false
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')
                    ) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        } else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    } else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })
        },

        /**
         * 質問ソート順更新
         *
         * @param {object} question
         * @param {string} type
         */
        onClickOrder: function (question, type) {
            const endpoint = constants.admin.health_survey_questions.endpoint.base

            axios.put(`${endpoint}/${question.id}/order`, { type: type })
                .then(() => {
                    this.fetchQuestions()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                } )
        },

        /**
         * アイテムソート順更新
         *
         * @param {number} idx
         * @param {string} type
         */
        onClickItemOrder: function (idx, type) {
            const items = this.question.items

            if (type === 'up') {
                if (idx > 0) {
                    items[idx - 1].order += 1
                    items[idx].order -= 1
                }
            }
            else if (type === 'down') {
                if (idx < items.length - 1) {
                    items[idx].order += 1
                    items[idx + 1].order -= 1
                }
            }
            this.question.items.sort((a, b) => a.order - b.order)
        },

        /**
         * 質問デッキ編集ボタン押下時
         */
        onClickHealthSurveyTemplateEdit: function () {
            bus.$emit('open-modal-admin-edit-health-survey-template', this.healthSurveyTemplate)
        },

        /**
         * 質問デッキ削除ボタン押下時
         */
        onClickHealthSurveyTemplateDelete: function () {
            bus.$emit('open-modal-admin-delete-health-survey-template', this.healthSurveyTemplate)
        },
    },
}
</script>

<style scoped lang="scss">
.inputScore {
    width: 100px;
}

.modalDeleteItems {
    .modalDeleteItemsInner {
        div {
            &:nth-child(1) {
                width: 70%;
            }
            &:nth-child(2) {
                width: 30%;
            }
        }
    }
}

.btn-settings {
    width: 100%;
    max-width: 200px;
    display: block;
    margin: 0 auto;
}

.vc-question-title {
    max-width: 650px;

    @media screen and (max-width: 1199px) {
        max-width: 545px;
    }
}

.vc-toggle-wrapper {
    margin-left: 6px;
}

.tab-medical-course-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
}

a.active {
    .tab-medical-course-name {
        color: #fff;
    }
}

.tab-doctor-menu-title {
    font-size: 15px;
    font-weight: bold;
}

.tabContentImportExport {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
</style>
